import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-land-revenue-real-estate-laws',
  templateUrl: './land-revenue-real-estate-laws.component.html',
  styleUrls: ['./land-revenue-real-estate-laws.component.css']
})
export class LandRevenueRealEstateLawsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
